import { render, staticRenderFns } from "./AttendanceCorrectionsMain.vue?vue&type=template&id=19f45a3a"
import script from "./AttendanceCorrectionsMain.vue?vue&type=script&lang=js"
export * from "./AttendanceCorrectionsMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports